import {OnInit, ElementRef, Host, OnChanges, SimpleChanges} from '@angular/core';
import { Directive, HostListener, Input } from '@angular/core';
import * as $ from "jquery";
import {NotificationService} from "../../services/notification/notification.service";

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[copyable]'
})
export class CopyableDirective implements OnInit, OnChanges {
  @Input() copyable: any;

  constructor(public element: ElementRef, private notificationService: NotificationService) {}

  ngOnInit(): void {
    let el = this.element.nativeElement;
    el.classList.add('btn-link');
    let copyableDom = document.createElement('i');
    copyableDom.classList.add('fa');
    copyableDom.classList.add('fa-copy');
    copyableDom.style.cursor = 'pointer';
    copyableDom.style['margin-left'] = '5px';
    copyableDom.style['margin-top'] = '3px';
    copyableDom.addEventListener("click", this.onButtonClick.bind(this));
    $(el).after($(copyableDom));
  }

  onButtonClick() {
    const el = document.createElement('input');
    el.value = this.copyable;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    el.style.opacity = '0';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    this.notificationService.show('copy-text', `copied!`, 1000);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.copyable = changes['copyable'].currentValue;
  }
}
